import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';
import { trackEvent } from '@/utils/analytics';
import { useSearchSpotlightOptional } from './SearchSpotlightContext';
import { getSpotlightShortcutLabel } from './searchSpotlightHelpers';
import './searchSpotlight.css';

export function SearchSpotlightButton({ navIconClass = '' }: { navIconClass?: string }) {
  const spotlight = useSearchSpotlightOptional();
  if (!spotlight) return null;

  const shortcut = getSpotlightShortcutLabel();

  return (
    <button
      type="button"
      className="search-spotlight-trigger"
      onClick={() => {
        trackEvent({
          name: 'search_spotlight_open',
          buttonId: 'search_spotlight_header_button',
          label: 'Open search spotlight',
          page: 'global',
          section: 'top_navigation',
          feature: 'search_spotlight',
          eventCategory: 'search',
        });
        spotlight.open();
      }}
      aria-label="Search"
      aria-haspopup="dialog"
      aria-expanded={spotlight.isOpen}
      aria-keyshortcuts="Meta+K Control+K"
      title={`Search (${shortcut})`}
      data-testid="search-spotlight-button"
    >
      <MagnifyingGlassIcon className={`nav-icon h-6 w-6 ${navIconClass}`} />
    </button>
  );
}
